import { Box, Collapse, useTheme } from "@mui/material";
import { Typography } from "@powerdiary/components-library/lib";
import { useRef } from "react";
import { useClientPortalConfigContext } from "../../../../../context/ClientPortalConfig.ctx";

interface TermsAndConditionsContentProps {
    termsAndConditionsVisibility: boolean;
}
export default function TermsAndConditionsContent({ termsAndConditionsVisibility }: TermsAndConditionsContentProps) {
    const contentRef = useRef<HTMLDivElement>(null);
    const {
        clientPortalConfig: { termsAndConditions },
    } = useClientPortalConfigContext();
    const theme = useTheme();

    return (
        <Collapse in={termsAndConditionsVisibility} collapsedSize={0} timeout="auto">
            <Box id="terms-collapse-content" ref={contentRef} data-test-id="section_terms_and_conditions">
                <Typography variant="paragraphMediumBold" color={theme.palette.text.secondary}>
                    Terms & Conditions
                </Typography>
                <Typography
                    data-test-id="text_booking_instructions"
                    variant="paragraphMediumRegular"
                    color="text.secondary"
                    component="div"
                    dangerouslySetInnerHTML={{ __html: termsAndConditions ?? "" }}
                />
            </Box>
        </Collapse>
    );
}
